import { useCallback, useState } from 'react';
import { loadTimeZoneChoice, resolveTimeZone, saveTimeZoneChoice, type ResolvedTimeZone, type TimeZoneChoice } from './timeZone';

/** The viewer's time-zone choice for Employee Payslip event times (EPN-239). Read once when the page mounts; `setChoice` also remembers it. */
export function useTimeZoneChoice(): { choice: TimeZoneChoice; setChoice: (choice: TimeZoneChoice) => void; resolved: ResolvedTimeZone } {
  const [choice, setChoiceState] = useState<TimeZoneChoice>(() => loadTimeZoneChoice());
  const setChoice = useCallback((next: TimeZoneChoice) => {
    saveTimeZoneChoice(next);
    setChoiceState(next);
  }, []);
  return { choice, setChoice, resolved: resolveTimeZone(choice) };
}
